import React from 'react'

const InputMoney = ({ name, value, onChange, style }) => {
	const handleChange = (e) => {
		onChange(e.target.name, e.target.value)
	}

	return (
		<div className='form-group'>
			<label>Desired Loan Amount</label>
			<div className='input-group mb-2'>
				<div className='input-group-text input-group-text-icon'>$</div>
				<input
					type='text'
					className='form-control form-control-lg'
					name={name}
					id={name}
					value={value}
					onChange={handleChange}
					style={style}
				/>
			</div>
		</div>
	)
}

export default InputMoney
